import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dictionary from '../../../model/Dictionary';
import './PassengerInfo.css';
import SelectedMealListItems from '../../../containers/meals/common/mealsList/SelectedMealListItems';
import _ from 'lodash';
import MealInfo from '../mealInfo/MealInfo';

class PassengerInfo extends Component {
  static propTypes = {
    passengerNum: PropTypes.string,
    passenger: PropTypes.object,
    seat: PropTypes.string,
    meals: PropTypes.arrayOf(PropTypes.object),
    toggleMealDetails: PropTypes.func,
    showMealDetails: PropTypes.string,
  };

  render () {
    const { passengerNum, passenger, seat, meals, showMealDetails, toggleMealDetails } = this.props;
    let noPassengerMeals = !passenger || !passenger.meals || _.isEmpty(passenger.meals);
    noPassengerMeals =
      noPassengerMeals ||
      (passenger.meals.length === 1 && (!passenger.meals[ 0 ] || !passenger.meals[ 0 ].id));

    return (
      <div className='row passenger-info'>
        <div className='column passenger col-md-3 col-sm-6 col-6'>
          <h6>
            {Dictionary.review.passenger} {passengerNum}
          </h6>
          <p>
            {passenger.firstName} {passenger.lastName}
          </p>
        </div>
        <div className='column passenger-seats col-md-3 col-sm-6 col-6'>
          <h6>{Dictionary.review.seat}</h6>
          <p>{seat || Dictionary.review.noSeat}</p>
        </div>
        <div className='column passenger-meals-wrapper col-md-6 col-sm-12 col-12'>
          <h6>
            <span>{Dictionary.review.meal}</span>
            {noPassengerMeals ? null : (
              <div onClick={() => toggleMealDetails(passenger.id)}>...</div>
            )}
          </h6>
          <div className='row passenger-meals'>
            {noPassengerMeals ? (
              <p className='no-meals'>{Dictionary.review.noMeals}</p>
            ) : (
              <div className='row'>
                <SelectedMealListItems meals={meals} className='mr-3' passenger={passenger} />
              </div>
            )}
          </div>
        </div>
        {showMealDetails === passenger.id ? <MealInfo passenger={passenger} meals={meals} /> : null}
      </div>
    );
  }
}

export default PassengerInfo;



// WEBPACK FOOTER //
// ./src/components/review/passengerInfo/PassengerInfo.js